"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sdk = void 0;
const constants_1 = require("../shared/constants");
const axios_1 = __importDefault(require("axios"));
class SDK {
    constructor(wikiName) {
        this.wikiName = wikiName;
    }
    reportClientError(error) {
        console.error(error);
        window.alert('Something went wrong, reload page and try again\n' + error);
    }
    getPage(name) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/api/wikidot/pages/${this.wikiName}/${name.toLowerCase()}`;
            const response = yield axios_1.default.get(url);
            return response.data.page;
        });
    }
    tetherWikidotAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield axios_1.default.post('/wikidot/api/tether-account');
                return response.data && response.data.code;
            }
            catch (error) {
                const response = error.response;
                if (response && response.data && response.data.code) {
                    return response.data.code;
                }
                else {
                    throw error;
                }
            }
        });
    }
    getDraftsList() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get('/api/drafts');
            return response.data;
        });
    }
    getDraft(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`/api/drafts/${id}`);
            return response.data;
        });
    }
    deleteDraft(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield yield axios_1.default.delete(`/api/drafts/${id}`);
            return response.data;
        });
    }
    createDraft(title, content) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield yield axios_1.default.post('/api/drafts', { title, content });
            return response.data;
        });
    }
    updateDraft(id, title, content) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield yield axios_1.default.post(`/api/drafts/${id}`, { title, content });
            return response.data;
        });
    }
}
exports.sdk = new SDK(constants_1.WIKI_NAME);
if (typeof window !== 'undefined') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.sdk = exports.sdk;
}
//# sourceMappingURL=sdk.js.map